module.exports = __webpack_public_path__ + "static/kuo_toa_whip-eac9fb49bc8d7b66956077db5ca3c53c.jpg";